import { atom } from 'nanostores'

export enum PCSPageNames {
	Home = 'home',
	Search = 'search',
	Detail = 'detail',
}

export const pageName = atom('')

export function setPageName(name: PCSPageNames) {
	if (Object.values(PCSPageNames).includes(name)) {
		console.log('Set page name:', name)
		pageName.set(name)
	} else {
		console.error('Invalid page name:', name)
	}
}
